import { RouteRecordRaw } from "vue-router";
import HomePage from "@/modules/Report/pages/HomePage.vue";

const reportRoutes: Array<RouteRecordRaw> = [{
  path:"/report",
  component:HomePage
}];

export default reportRoutes;
